import { useMemo } from "react";
import {matchPath, useLocation} from "react-router-dom";
import {userRoles} from "@awe-web/shared/lib";
import * as routesObject from "./routes.js";

const routes = Object.values(routesObject)
  .filter((route) => typeof route.path === "function");

const findRoute = (location) =>
  routes.find((route) => matchPath(location.pathname, route.path()));

export const belongsToGroup = (location, group) => {
  const {groups = []} = findRoute(location) || {};
  return groups.includes(group);
};

export const isUserRoleAllowed = (userRole, location) => {
  const {allowedUserRoles = []} = findRoute(location) || {};
  return allowedUserRoles.includes(userRole);
};

export const requiresAuthentication = (location) =>
  !isUserRoleAllowed(userRoles.ANONYMOUS, location);

export function useBelongsToGroup(group) {
  const location = useLocation();
  return useMemo(() => belongsToGroup(location, group), [group, location]);
}
